export const guestListColumns = [
  {
    Header: "Full Name",
    accessor: "first_name",
  },
  {
    Header: "Email",
    accessor: "email",
  },
  {
    Header: "Phone",
    accessor: "phone",
  },
  {
    Header: "Date of Birth",
    accessor: "date_of_birth",
  },
  {
    Header: "Nationality",
    accessor: "nationality",
  },
  {
    Header: "Actions",
    accessor: "actions",
    disableSortBy: true,
  },
];

export const assignedEmpListTableData1 = [
  {
    id: "1",
    empName: "Jony Morg",
    shift: "Morning Shift",
    rosterStart: "2024-01-11",
    rosterEnd: "2024-01-26",
  },
  {
    id: "2",
    empName: "Alka Murty",
    shift: "Night Shift",
    rosterStart: "2021-12-01",
    rosterEnd: "2022-10-24",
  },
  {
    id: "3",
    empName: "Tommy Leo",
    shift: "Morning Shift, Night Shift",
    rosterStart: "2021-11-21",
    rosterEnd: "2021-11-30",
  },
  {
    id: "4",
    empName: "Panda Prty",
    shift: "Night Shift",
    rosterStart: "2024-12-01",
    rosterEnd: "2024-10-24",
  },
  {
    id: "5",
    empName: "Aky Reo",
    shift: "Morning Shift, Night Shift",
    rosterStart: "2023-11-21",
    rosterEnd: "2023-11-30",
  },
  {
    id: "6",
    empName: "Samuel Johnson",
    shift: "Morning Shift",
    rosterStart: "2024-05-01",
    rosterEnd: "2024-05-15",
  },
  {
    id: "7",
    empName: "Emily Watson",
    shift: "Night Shift",
    rosterStart: "2024-06-01",
    rosterEnd: "2024-06-15",
  },
  {
    id: "8",
    empName: "Chris Evans",
    shift: "Morning Shift, Night Shift",
    rosterStart: "2024-07-01",
    rosterEnd: "2024-07-15",
  },
  {
    id: "9",
    empName: "Lucy Liu",
    shift: "Night Shift",
    rosterStart: "2024-08-01",
    rosterEnd: "2024-08-15",
  },
  {
    id: "10",
    empName: "Michael Jordan",
    shift: "Morning Shift, Night Shift",
    rosterStart: "2024-09-01",
    rosterEnd: "2024-09-15",
  },
];
export const assignedEmpListTableData = [
  {
    firstName: "John",
    lastName: "Doe",
    email: "john.doe@example.com",
    phone: "+1234567890",
    country_code: "+1",
    fatherName: "Richard Doe",
    gender: "Male",
    occupation: "Software Developer",
    date_of_birth: "1990-01-01",
    nationality: "American",
  },
  {
    firstName: "Jane",
    lastName: "Smith",
    email: "jane.smith@example.com",
    phone: "+447911123456",
    country_code: "+44",
    fatherName: "Michael Smith",
    gender: "Female",
    occupation: "Graphic Designer",
    date_of_birth: "1992-05-15",
    nationality: "British",
  },
  {
    firstName: "Carlos",
    lastName: "Gomez",
    email: "carlos.gomez@example.com",
    phone: "+5215512345678",
    country_code: "+52",
    fatherName: "Luis Gomez",
    gender: "Male",
    occupation: "Mechanical Engineer",
    date_of_birth: "1985-11-23",
    nationality: "Mexican",
  },
  {
    firstName: "Aisha",
    lastName: "Khan",
    email: "aisha.khan@example.com",
    phone: "+971501234567",
    country_code: "+971",
    fatherName: "Omar Khan",
    gender: "Female",
    occupation: "Marketing Manager",
    date_of_birth: "1988-07-10",
    nationality: "Emirati",
  },
  {
    firstName: "Liam",
    lastName: "O'Brien",
    email: "liam.obrien@example.com",
    phone: "+353851234567",
    country_code: "+353",
    fatherName: "Seamus O'Brien",
    gender: "Male",
    occupation: "Data Analyst",
    date_of_birth: "1995-03-30",
    nationality: "Irish",
  },
];
